// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Inventory-Transfer-List-__List___1GoI3","table-header":"app-pages-Inventory-Transfer-List-__List___N21bz","table-content-wrapper":"app-pages-Inventory-Transfer-List-__List___YFC26","table-content":"app-pages-Inventory-Transfer-List-__List___1b6_7","selected":"app-pages-Inventory-Transfer-List-__List___1O7fl","parentRow":"app-pages-Inventory-Transfer-List-__List___XTMTs"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Inventory/Transfer/List/List.css
// module id = 2394
// module chunks = 0